import React from 'react'
import Header from 'components/app/Header'
import PageBody from 'components/app/PageBody'
import Breadcrumb from 'components/app/Breadcrumb'
import ReportHeader from 'components/report/view/ReportHeader'
import NotFound from 'components/router/NotFound'

type Props = {
  errorMessage?: string
}

export default function NotFoundPage(props: Props) {
  const { errorMessage } = props

  return (
    <PageBody
      renderHeader={() => (
        <>
          <Header>
            <Breadcrumb crumbs={[{ label: '404', value: '404' }]} />
          </Header>
          <ReportHeader />
        </>
      )}
      renderContent={() => <NotFound errorMessage={errorMessage} />}
    />
  )
}
